import type { OrderPageData } from '../api/models/OrderPageData';

/**
 * Transforms an upload.io image URL to use the image processing endpoint with a width limit.
 * Swaps `/raw/` to `/image/` and appends `?w=<maxWidth>`.
 * Non-upload.io URLs or non-image URLs (e.g. videos) are returned as-is.
 */
export function optimizeImageUrl(url: string | undefined, maxWidth: number): string | undefined {
  if (!url) return undefined;
  if (!url.includes('upcdn.io')) return url;
  const optimized = url.includes('/raw/') ? url.replace('/raw/', '/image/') : url;
  return `${optimized}${optimized.includes('?') ? '&' : '?'}w=${maxWidth}`;
}

/**
 * Gets the primary photo URL from an order page.
 * First checks order_page_images (returns the one with lowest order value),
 * then falls back to the legacy photo field.
 * If maxWidth is provided, the URL is optimized for that width.
 */
export function getPrimaryPhoto(orderPage: OrderPageData | null | undefined, maxWidth?: number): string | undefined {
  let url: string | undefined;
  if (orderPage?.order_page_images?.length) {
    url = [...orderPage.order_page_images].sort((a, b) => a.order - b.order)[0]?.value;
  }
  if (!url) return undefined;
  return maxWidth ? optimizeImageUrl(url, maxWidth) : url;
}
